export const generateTeamUrl = (token) => {
  return `${window.location.origin}/t/${token}`;
};

export const generateLeaderboardUrl = (token) => {
  return `${window.location.origin}/lb/${token}`;
};

export const copyToClipboard = async (text) => {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    // Fallback for older browsers
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    return true;
  } catch {
    return false;
  }
};

export const shareLink = async (url, title, text) => {
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return "shared";
    } catch (error) {
      if (error.name === "AbortError") return false;
      // Fall through to copy
    }
  }
  const copied = await copyToClipboard(url);
  return copied ? "copied" : false;
};
